const Placeholder = ( { domain } ) => {
  return <div className="vs aling-center justify-center">
    <p>
      El dominio <strong>{ domain }</strong> no cuenta con contactos registrados para su notificaci&oacute;n.
    </p>
  </div>
}

export default Placeholder
